import { render, staticRenderFns } from "./inviteProfessional.vue?vue&type=template&id=290a8414&"
import script from "./inviteProfessional.vue?vue&type=script&lang=js&"
export * from "./inviteProfessional.vue?vue&type=script&lang=js&"
import style0 from "./inviteProfessional.vue?vue&type=style&index=0&id=290a8414&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports